import React, { Fragment, useState } from "react";

import Footer from "../../layout/footer";
import Header from "../../layout/header";
import "./selectplan.css";
import Select from 'react-select';

export default function DomainSelect() {

  const options = [
    { value: 'chocolate', label: 'virendra111.com' },
    { value: 'strawberry', label: 'virendra222.com' },
    { value: 'vanilla', label: 'virendra333.in' },
    { value: 'vanilla1', label: 'virendra444.in' },
    { value: 'vanilla2', label: 'virendra555.in' },
  ];
  const [selectedOption, setSelectedOption] = useState([]);

  const [searchValue, setSearchValue] = useState('');

  async function handleSearchDomain(item) {
    if (searchValue.length < 4)
      setSearchValue(item);
  }
  async function handleSelectedOption(item) {
    const index = await selectedOption.findIndex((e) => e.label === item.label);
    if (index <= -1 && selectedOption.length <= 4) {
      setSelectedOption([...selectedOption, item])
    }
  }

  const image = 'https://mydigitalindia.app/DigitalIndiaAppApi/upload/template/theme-1690277217493-381346239.png'
  return (
    <Fragment>
      {/* <Header /> */}
      <section className="banner-section1">
        <div className="container">
          <div className="banner-div">
            <div className="row">
              <div className="col-lg-12">
                <div className="banner-txt">
                  <h3>Select Domain</h3>
                  <div className="container cont_form_box">
                    <div className="col-lg-12">
                      <div className="row pos-adj domain_box">

                        {/* <div className="col-lg-6">
                          <img className="w-100 thumbnail" style={{ height: 400, backgroundImage: `url(${image})` }} />
                        </div> */}
                        <div className="col-lg-6">
                          <div className="pri-txt">
                            You can select 4 domains.
                          </div>
                          <div className="text-center">

                            <div className="form-group">
                              <Select
                                // defaultValue={selectedOption}
                                // onSelect={setSelectedOption}
                                // onChange={setSelectedOption}
                                onChange={handleSelectedOption}
                                onInputChange={(input) => { console.log('vvv ', input); handleSearchDomain(input) }}
                                options={options}
                                // isMulti={true}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Enter Your Domain..."
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="domain_selected">
                            <div className="text-center"><p className="dm_head_text">Your selected domains</p></div>
                            <ol className="dmn_list">
                              {selectedOption && selectedOption.length > 0 && selectedOption.map((item, i) => {
                                i++
                                return (
                                  <li className={`dmn_item d-flex`}><span>{item.label}</span> <span className="select_dmn_edit"><i className="fa fa-edit" ></i></span> </li>
                                )
                              })}
                            </ol>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="mt-4 mb-4">
                            <button className="btn theme-btn btn-style-one dmn_submit">Submit</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </Fragment>
  );
}